import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const getAuthHeader = () => {
  const token = localStorage.getItem('token');
  return { Authorization: `Bearer ${token}` };
};

export const api = {
  // Clientes
  getClientes: () => axios.get(`${API}/clientes`, { headers: getAuthHeader() }),
  getCliente: (id) => axios.get(`${API}/clientes/${id}`, { headers: getAuthHeader() }),
  createCliente: (data) => axios.post(`${API}/clientes`, data, { headers: getAuthHeader() }),
  updateCliente: (id, data) => axios.put(`${API}/clientes/${id}`, data, { headers: getAuthHeader() }),
  deleteCliente: (id) => axios.delete(`${API}/clientes/${id}`, { headers: getAuthHeader() }),

  // Processos
  getProcessos: () => axios.get(`${API}/processos`, { headers: getAuthHeader() }),
  getProcesso: (id) => axios.get(`${API}/processos/${id}`, { headers: getAuthHeader() }),
  createProcesso: (data) => axios.post(`${API}/processos`, data, { headers: getAuthHeader() }),
  updateProcesso: (id, data) => axios.put(`${API}/processos/${id}`, data, { headers: getAuthHeader() }),
  deleteProcesso: (id) => axios.delete(`${API}/processos/${id}`, { headers: getAuthHeader() }),
  getTribunalInfo: (id) => axios.get(`${API}/processos/${id}/tribunal`, { headers: getAuthHeader() }),

  // Movimentações
  getMovimentacoes: (processoId) => axios.get(`${API}/processos/${processoId}/movimentacoes`, { headers: getAuthHeader() }),
  createMovimentacao: (processoId, data) => axios.post(`${API}/processos/${processoId}/movimentacoes`, data, { headers: getAuthHeader() }),

  // Financeiro
  getFinanceiro: () => axios.get(`${API}/financeiro`, { headers: getAuthHeader() }),
  createFinanceiro: (data) => axios.post(`${API}/financeiro`, data, { headers: getAuthHeader() }),
  updateFinanceiro: (id, data) => axios.put(`${API}/financeiro/${id}`, data, { headers: getAuthHeader() }),

  // Dashboard
  getDashboard: () => axios.get(`${API}/dashboard`, { headers: getAuthHeader() }),

  // Audiências
  getAudiencias: () => axios.get(`${API}/audiencias`, { headers: getAuthHeader() }),
  createAudiencia: (data) => axios.post(`${API}/audiencias`, data, { headers: getAuthHeader() }),
  updateAudiencia: (id, data) => axios.put(`${API}/audiencias/${id}`, data, { headers: getAuthHeader() }),
  deleteAudiencia: (id) => axios.delete(`${API}/audiencias/${id}`, { headers: getAuthHeader() }),

  // Administração
  getUsuarios: () => axios.get(`${API}/admin/usuarios`, { headers: getAuthHeader() }),
  createUsuario: (data) => axios.post(`${API}/admin/usuarios`, data, { headers: getAuthHeader() }),
  updateUsuario: (id, data) => axios.put(`${API}/admin/usuarios/${id}`, data, { headers: getAuthHeader() }),
  deleteUsuario: (id) => axios.delete(`${API}/admin/usuarios/${id}`, { headers: getAuthHeader() }),

  // Clientes - Processos
  getProcessosCliente: (clienteId) => axios.get(`${API}/clientes/${clienteId}/processos`, { headers: getAuthHeader() }),

  // Documentos
  uploadDocumento: (clienteId, formData) => axios.post(`${API}/clientes/${clienteId}/documentos`, formData, { 
    headers: getAuthHeader()
  }),
  getDocumentosCliente: (clienteId) => axios.get(`${API}/clientes/${clienteId}/documentos`, { headers: getAuthHeader() }),
  downloadDocumento: (documentoId) => `${API}/documentos/${documentoId}/download`,
  updateDocumento: (documentoId, data) => axios.put(`${API}/documentos/${documentoId}`, data, { headers: getAuthHeader() }),
  deleteDocumento: (documentoId) => axios.delete(`${API}/documentos/${documentoId}`, { headers: getAuthHeader() }),

  // Atendimentos
  getAtendimentos: () => axios.get(`${API}/atendimentos`, { headers: getAuthHeader() }),
  getAtendimento: (id) => axios.get(`${API}/atendimentos/${id}`, { headers: getAuthHeader() }),
  createAtendimento: (data) => axios.post(`${API}/atendimentos`, data, { headers: getAuthHeader() }),
  updateAtendimento: (id, data) => axios.put(`${API}/atendimentos/${id}`, data, { headers: getAuthHeader() }),
  deleteAtendimento: (id) => axios.delete(`${API}/atendimentos/${id}`, { headers: getAuthHeader() }),
  converterAtendimentoParaCliente: (id) => axios.post(`${API}/atendimentos/${id}/converter-cliente`, {}, { headers: getAuthHeader() }),

  // Orçamentos
  getOrcamentos: () => axios.get(`${API}/orcamentos`, { headers: getAuthHeader() }),
  getOrcamento: (id) => axios.get(`${API}/orcamentos/${id}`, { headers: getAuthHeader() }),
  createOrcamento: (data) => axios.post(`${API}/orcamentos`, data, { headers: getAuthHeader() }),
  updateOrcamento: (id, data) => axios.put(`${API}/orcamentos/${id}`, data, { headers: getAuthHeader() }),
  deleteOrcamento: (id) => axios.delete(`${API}/orcamentos/${id}`, { headers: getAuthHeader() }),
  aprovarOrcamento: (id) => axios.put(`${API}/orcamentos/${id}/aprovar`, {}, { headers: getAuthHeader() }),
  rejeitarOrcamento: (id) => axios.put(`${API}/orcamentos/${id}/rejeitar`, {}, { headers: getAuthHeader() }),
  gerarPdfOrcamento: (id, documentos) => axios.post(`${API}/orcamentos/${id}/gerar-pdf`, documentos, { 
    headers: getAuthHeader(),
    responseType: 'blob'
  }),

  // Anotações
  getAnotacoes: () => axios.get(`${API}/anotacoes`, { headers: getAuthHeader() }),
  getAnotacoesHoje: () => axios.get(`${API}/anotacoes/hoje`, { headers: getAuthHeader() }),
  createAnotacao: (data) => axios.post(`${API}/anotacoes`, data, { headers: getAuthHeader() }),
  updateAnotacao: (id, data) => axios.put(`${API}/anotacoes/${id}`, data, { headers: getAuthHeader() }),
  concluirAnotacao: (id) => axios.put(`${API}/anotacoes/${id}/concluir`, {}, { headers: getAuthHeader() }),
  deleteAnotacao: (id) => axios.delete(`${API}/anotacoes/${id}`, { headers: getAuthHeader() }),

  // Tipos de Documentos
  getTiposDocumentos: () => axios.get(`${API}/tipos-documentos`, { headers: getAuthHeader() }),
  createTipoDocumento: (data) => axios.post(`${API}/tipos-documentos`, data, { headers: getAuthHeader() }),
  deleteTipoDocumento: (id) => axios.delete(`${API}/tipos-documentos/${id}`, { headers: getAuthHeader() }),

  // Chat
  getChatUsuarios: () => axios.get(`${API}/chat/usuarios`, { headers: getAuthHeader() }),
  getConversas: () => axios.get(`${API}/chat/conversas`, { headers: getAuthHeader() }),
  getMensagens: (conversaId) => axios.get(`${API}/chat/conversas/${conversaId}/mensagens`, { headers: getAuthHeader() }),
  enviarMensagem: (data) => axios.post(`${API}/chat/mensagens`, data, { headers: getAuthHeader() }),
  getMensagensNaoLidas: () => axios.get(`${API}/chat/nao-lidas`, { headers: getAuthHeader() }),
  marcarMensagensLidas: (conversaId) => axios.put(`${API}/chat/conversas/${conversaId}/marcar-lidas`, {}, { headers: getAuthHeader() }),
  uploadChatFile: (formData) => axios.post(`${API}/chat/upload`, formData, { headers: getAuthHeader() }),
  getChatFileUrl: (filename) => `${API}/chat/files/${filename}`,
  getChatFileViewUrl: (filename, token) => `${BACKEND_URL}/api/chat/files/view/${filename}?token=${token}`,
  sendTypingIndicator: (data) => axios.post(`${API}/chat/typing`, data, { headers: getAuthHeader() }),
  adicionarReacao: (mensagemId, emoji) => axios.post(`${API}/chat/mensagens/${mensagemId}/reacao`, { mensagem_id: mensagemId, emoji }, { headers: getAuthHeader() }),
  getReacoes: (mensagemId) => axios.get(`${API}/chat/mensagens/${mensagemId}/reacoes`, { headers: getAuthHeader() })
};